<template>
<b-card header="Profile">
  <b-form id="user-profile">
    <b-row>
      <b-col xs="12" md="6">
        <div class="large-12 medium-12 small-12 cell" style="margin-bottom: 10px;">
          <label>Avatar
            <!-- <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/> -->
            <b-form-file v-model="file" id="file" ref="file" placeholder="Choose a file..." v-on:change="handleFileUpload()"></b-form-file>
          </label>
          <!-- <button v-on:click="submitFile()">Submit</button> -->
          <br/>
          <b-button type="button" size="sm" variant="primary" v-on:click="submitFile()">Upload</b-button>
        </div>
      </b-col>
      <b-col xs="12" md="6">
        <div class="image-upload" style="display: flex; justify-content: center;">
          <label for="file-input">
            <div class="container">
              <img class="img-avatar" :src="user.avatar" :alt="user.email" style="width: 100px;">
            </div>
          </label>
        </div>
      </b-col>
  </b-row>
    <b-row>
      <b-col xs="12" md="6">
    <b-form-group>
      <b-input-group>
        <b-input-group-prepend>
          <b-input-group-text>Phone</b-input-group-text>
        </b-input-group-prepend>
        <b-form-input type="text" v-model="formData.phone" placeholder="Phone" disabled></b-form-input>
        <b-input-group-append>
          <b-input-group-text><i class="fa fa-phone"></i></b-input-group-text>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
  </b-col>
    <b-col xs="12" md="6">
    <b-form-group>
      <b-input-group>
        <b-input-group-prepend>
          <b-input-group-text>Email</b-input-group-text>
        </b-input-group-prepend>
        <b-form-input type="text" v-model="formData.email" placeholder="Email" disabled></b-form-input>
        <b-input-group-append>
          <b-input-group-text><i class="fa fa-at"></i></b-input-group-text>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    </b-col>
  </b-row>

    <b-form-group>
      <b-input-group>
        <b-input-group-prepend>
          <b-input-group-text>Name</b-input-group-text>
        </b-input-group-prepend>
        <b-form-input type="text" v-model="formData.name" placeholder="Name"></b-form-input>
        <b-input-group-append>
          <b-input-group-text><i class="nav-icon icon-user"></i></b-input-group-text>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <b-row>
      <b-col xs="12" md="6">
        <div role="group" class="">
          <div role="group" class="input-group" style="height: 35px; margin-bottom: 15px;">
            <div class="input-group-prepend">
              <div class="input-group-text">Gender</div>
            </div>
            <b-form-select v-model="selectedGender" :options="genders" class="mb-3">
            </b-form-select>
          </div>
        </div>
      </b-col>
      <b-col xs="12" md="6">
        <div role="group" class="">
          <div role="group" class="input-group" style="height: 35px; margin-bottom: 15px;">
            <div class="input-group-prepend">
              <div class="input-group-text">Subscribe news</div>
            </div>
            <b-form-select v-model="selectedSubscribeNews" :options="subscribeNews" class="mb-3">
            </b-form-select>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-form-group>
      <b-input-group>
        <b-input-group-prepend>
          <b-input-group-text>Old password</b-input-group-text>
        </b-input-group-prepend>
        <b-form-input type="password" v-model="formData.oldPassword" placeholder="Old Password"></b-form-input>
        <b-input-group-append>
          <b-input-group-text><i class="nav-icon icon-lock"></i></b-input-group-text>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    <b-row>
      <b-col xs="12" md="6">
    <b-form-group>
      <b-input-group>
        <b-input-group-prepend>
          <b-input-group-text>New password</b-input-group-text>
        </b-input-group-prepend>
        <b-form-input type="password" v-model="formData.newPassword" placeholder="New Password"></b-form-input>
        <b-input-group-append>
          <b-input-group-text><i class="nav-icon icon-lock"></i></b-input-group-text>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
  </b-col>
<b-col xs="12" md="6">
    <b-form-group>
      <b-input-group>
        <b-input-group-prepend>
          <b-input-group-text>Confirm password</b-input-group-text>
        </b-input-group-prepend>
        <b-form-input type="password" v-model="formData.confirmPassword" placeholder="Confirm Password"></b-form-input>
        <b-input-group-append>
          <b-input-group-text><i class="nav-icon icon-lock"></i></b-input-group-text>
        </b-input-group-append>
      </b-input-group>
    </b-form-group>
    </b-col>
  </b-row>
    <div class="form-group form-actions">
      <b-button @click="modalShow = !modalShow" type="button" size="sm" variant="primary">Save</b-button>
    </div>
  </b-form>

  <b-modal v-model="modalShow" ok-title="Yes" cancel-title="No">
    Are you sure you want to submit changes to your profile?
    <div slot="modal-footer" class="w-100">

       <b-btn size="sm" class="float-right" variant="secondary" @click="modalShow=false" style="margin-left:10px;">
         No
       </b-btn>
       <b-btn size="sm" class="float-right" variant="primary" @click="submitUserProfile">
         Yes
       </b-btn>
     </div>

  </b-modal>
</b-card>
</template>

<script>
let qs = require('qs')
let axios = require('axios')
const constants = require('../shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
//const API_USER_DETAIL = BASE + '/api/users/detail'
const API_USER_EDIT = BASE + '/api/users/editProfile'
const API_UPLOAD_AVATAR = BASE + '/api/containers/uploadAvatar'
const API_CHANGE_PASSWORD = BASE + '/api/users/changePassword'

function postData (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    method: 'POST'
  })
    .then(res => res.json())
}

// async function getDataUser () {
//   let parameters = {
//     'client_id': constants.NEWPORT_CONST.CLIENT_ID,
//     'client_secret': constants.NEWPORT_CONST.CLIENT_SECRET,
//     'access_token': localStorage.getItem('token')
//   }
//   let res = await postData(API_USER_DETAIL, parameters)
//   return res.user
// }

async function changePassword (oldPassword, newPassword) {
  let parameters = {
    'client_id': constants.NEWPORT_CONST.CLIENT_ID,
    'client_secret': constants.NEWPORT_CONST.CLIENT_SECRET,
    'accessToken': localStorage.getItem('token'),
    'password': newPassword,
    'currentPassword': oldPassword
  }
  let res = await postData(API_CHANGE_PASSWORD, parameters)
  return res
}

async function editProfile (name, phone, email, gender, avatar, subscribenews) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    name: name,
    phone: phone,
    email: email,
    gender: gender,
    avatar: avatar,
    subscribeNews: subscribenews
  }
  let res = await postData(API_USER_EDIT, parameters)
  return res
}

export default {
  name: 'user-profile',
  data () {
    return {
      file: '',
      modalShow: false,
      avatar: '',
      passwordChange: false,
      profileUpdated: false,
      proceed: false,
      user: {},
      selectedGender: '',
      selectedSubscribeNews: '',
      subscribeNews: [
        { value: true, text: 'Yes' },
        { value: false, text: 'No' }
      ],
      genders: [
        { value: 'male', text: 'Male' },
        { value: 'female', text: 'Female' }
      ],
      formData: {
        userId: '',
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        accessToken: localStorage.getItem('token'),
        email: '',
        phone: '',
        userName: '',
        name: '',
        avatar: '',
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    }
  },
  mounted () {
    

      let localUserDetail = localStorage.getItem('localUserDetail')

      if(localUserDetail == null || localUserDetail == 'undefined') {
        constants.gotoLogin()
      } else {
        this.$data.user = JSON.parse(localUserDetail)
        this.$data.formData.name = this.$data.user.name
        this.$data.formData.email = this.$data.user.email
        this.$data.formData.phone = this.$data.user.phone
        this.$data.formData.userName = this.$data.user.username
        this.$data.formData.userId = this.$data.user.id
        this.$data.formData.avatar = this.$data.user.avatar
        this.$data.selectedGender = this.$data.user.gender
        if (!this.$data.selectedSubscribeNews) {
          this.$data.selectedSubscribeNews = false
        } else {
          this.$data.selectedSubscribeNews = this.$data.user.subscribe_news
        }
      }

  },
  methods: {
    resetInputPassword () {
      this.formData.newPassword = ''
      this.formData.confirmPassword = ''
      this.formData.oldPassword = ''
    },
    updatePassword (minPwdLength) {
      let oldPwd = this.formData.oldPassword
      let newPwd = this.formData.newPassword
      let confirmPwd = this.formData.confirmPassword

      if(oldPwd == '' && newPwd == '' && confirmPwd == '') {
        if (oldPwd.length < minPwdLength) {
        // do nothing. user only want to change data profile. To submit password change, old password must be filled.
      }
      else if (newPwd.length < minPwdLength) {
        alert('New password must have min. of ' + minPwdLength + ' characters.\nPlease try again.')
        this.resetInputPassword()
      }
      else if (newPwd === oldPwd) {
        this.resetInputPassword()
        alert('New password should be different than the old password.\nPlease try again.')
      }
      else if (newPwd !== confirmPwd) {
        this.resetInputPassword()
        alert('The password you entered as confirmation does not match the new password one.\nPlease confirm your password correctly.')
      } else {
        changePassword(oldPwd, newPwd).then(response => {
          if (response.status.errCode === '200') {
            this.resetInputPassword()
            console.log(response)
          } else if (response.status.errCode === '422') {
            this.resetInputPassword()
            alert('Request to change password failed.\nPlease check your old password and try again.')
          } else {
            alert('Please contact The Newport.')
          }
        }).catch(error => {
          console.error(error)
        })
      }
      }

      
    },
    updateProfile () {
      const minPwdLength = 5
      let name = this.formData.name
      let email = this.formData.email
      let phone = this.formData.phone
      let avatar = this.avatar
      let gender = this.selectedGender
      let subscribenews = this.selectedSubscribeNews

      if (avatar === '') {
        avatar = this.$data.user.avatar
      }
      editProfile(name, phone, email, gender, avatar, subscribenews).then(response => {
        console.log(response)
      }).catch(error => {
        console.error(error)
      })
      // password check
      this.updatePassword(minPwdLength)
    },
    getDateFormated (aDate) {
      var someDate = new Date(aDate)
      var dd = String(someDate.getDate())
      var mm = String(someDate.getMonth())
      var yyyyNow = someDate.getFullYear()
      if (mm.length < 2) mm = '0' + mm
      if (dd.length < 2) dd = '0' + dd
      var someDateFormatted = yyyyNow + '-' + mm + '-' + dd
      return someDateFormatted
    },
    submitUserProfile () {
      if (localStorage.getItem('token')) {
        this.updateProfile()
        this.modalShow = false
      }
    },
    submitFile () {
      let formData = new FormData()
      formData.append('avatar', this.file)
      formData.append('client_id', constants.NEWPORT_CONST.CLIENT_ID)
      formData.append('client_secret', constants.NEWPORT_CONST.CLIENT_SECRET)
      axios.post(API_UPLOAD_AVATAR,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
        .then(response => {
          console.log(JSON.stringify(response))
          this.avatar = response.avatar
          this.updateProfile()

          let localUserDetail = localStorage.getItem('localUserDetail')

          if(localUserDetail == null || localUserDetail == 'undefined') {
            constants.gotoLogin()

            } else {
              this.$data.user = JSON.parse(localUserDetail)
              this.$data.formData.name = this.$data.user.name
              this.$data.formData.email = this.$data.user.email
              this.$data.formData.phone = this.$data.user.phone
              this.$data.formData.userName = this.$data.user.username
              this.$data.formData.userId = this.$data.user.id
              this.$data.formData.avatar = this.$data.user.avatar
              this.$data.selectedGender = this.$data.user.gender
              if (!this.$data.selectedSubscribeNews) {
                this.$data.selectedSubscribeNews = false
              } else {
                this.$data.selectedSubscribeNews = this.$data.user.subscribe_news
              }
            }
          // getDataUser().then(response => {
          //   this.$data.user = response
          //   this.$data.formData.name = this.$data.user.name
          //   this.$data.formData.email = this.$data.user.email
          //   this.$data.formData.phone = this.$data.user.phone
          //   this.$data.formData.userName = this.$data.user.username
          //   this.$data.formData.userId = this.$data.user.id
          //   this.$data.formData.avatar = this.$data.user.avatar
          //   this.$data.selectedGender = this.$data.user.gender
          //   if (!this.$data.selectedSubscribeNews) {
          //     this.$data.selectedSubscribeNews = false
          //   } else {
          //     this.$data.selectedSubscribeNews = this.$data.user.subscribe_news
          //   }
          //   console.log('Success')
          // })
        })
        .catch(function () {
          console.log('FAILURE!!')
        })
    },
    handleFileUpload () {
      this.file = this.$refs.file.files[0]

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/UserProfile.vue